// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l11Jn7 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}

.RGGwp2 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.J73pL5 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: opacity 0.2s;
}

.J73pL5:hover:not(:disabled) {
  opacity: 0.7;
}

.J73pL5:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.Q05XEz {
  color: var(--surface-primary-medium, #d64000);
}

.DAJlzj {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.gU3ZJl {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.xGfvQ8 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.L3_Zpx {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.JbyvOa {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.s2eXhh {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-style: normal;
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.Og4uzx {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  width: 12px;
  height: 12px;
  opacity: 1;
}

.Og4uzx svg {
  width: 12px;
  height: 12px;
}

.mJ8be7 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.Ai6whM {
  display: block;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/ResetPassword/components/NewPassword/NewPassword.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".newPasswordWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.newPasswordHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.newPasswordBackButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: opacity 0.2s;\n}\n\n.newPasswordBackButton:hover:not(:disabled) {\n  opacity: 0.7;\n}\n\n.newPasswordBackButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.newPasswordBackIcon {\n  color: var(--surface-primary-medium, #d64000);\n}\n\n.newPasswordTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.newPasswordSubtitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.newPasswordField {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.newPasswordInputWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.newPasswordLabelContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.newPasswordLabel {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-style: normal;\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.newPasswordInfoIcon {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n  opacity: 1;\n}\n\n.newPasswordInfoIcon svg {\n  width: 12px;\n  height: 12px;\n}\n\n.newPasswordActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.tooltipContent {\n  display: block;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newPasswordWrapper": `l11Jn7`,
	"newPasswordHeader": `RGGwp2`,
	"newPasswordBackButton": `J73pL5`,
	"newPasswordBackIcon": `Q05XEz`,
	"newPasswordTitle": `DAJlzj`,
	"newPasswordSubtitle": `gU3ZJl`,
	"newPasswordField": `xGfvQ8`,
	"newPasswordInputWrapper": `L3_Zpx`,
	"newPasswordLabelContainer": `JbyvOa`,
	"newPasswordLabel": `s2eXhh`,
	"newPasswordInfoIcon": `Og4uzx`,
	"newPasswordActions": `mJ8be7`,
	"tooltipContent": `Ai6whM`
};
module.exports = ___CSS_LOADER_EXPORT___;
